import { createQuestionValueMap, getUpdatedItems, mapToTupleArray, PageJson } from "../../../../common/summary-common/applicationSummary";
import { ConfirmationData, updateMapWithFields } from "../../../../common/summary-common/confirmationData";

export const defaultMedicalInformation: Map<string, ConfirmationData> = new Map([
    ["f6fb3378-eb02-4603-a3e7-153045ccaef6", { fontWeight: "bold" }],
    ["ad1e32bd-6976-4068-80c1-6ccbd441e1ed-opt1", { type: "checkbox" }],
    ["ad1e32bd-6976-4068-80c1-6ccbd441e1ed-opt2", { type: "checkbox" }],
    ["ad1e32bd-6976-4068-80c1-6ccbd441e1ed-opt3", { type: "checkbox" }],
    ["ad1e32bd-6976-4068-80c1-6ccbd441e1ed-opt4", { type: "checkbox" }],
    ["d97c485f-51db-40fe-8304-6cc457a095a4-opt1", { type: "checkbox" }],
    ["d97c485f-51db-40fe-8304-6cc457a095a4-opt2", { type: "checkbox" }],
    ["d97c485f-51db-40fe-8304-6cc457a095a4-opt3", { type: "checkbox" }],
    ["d97c485f-51db-40fe-8304-6cc457a095a4-opt4", { type: "checkbox" }],
    ["4ea018bf-7570-4e4c-adc5-617077134715-opt1", { type: "checkbox" }],
    ["4ea018bf-7570-4e4c-adc5-617077134715-opt2", { type: "checkbox" }],
    ["4ea018bf-7570-4e4c-adc5-617077134715-opt3", { type: "checkbox" }],
    ["4ea018bf-7570-4e4c-adc5-617077134715-opt4", { type: "checkbox" }],
    ["none", { label: "Ninguna de las anteriores.", type: "checkbox", showBorder: true }],

])

const cardiacDiseaseInfo = new Map<string, ConfirmationData>([
    ["a504d0fe-8174-41c8-8f68-8f387bae0678", { fontWeight: "bold", color: "skyblue" }],
    ["3405ff90-7911-4310-9b77-1f98a4707572", { fontWeight: "bold" }],
    ["4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt0", { type: "checkbox" }],
    ["4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt1", { type: "checkbox" }],
    ["4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt2", { type: "checkbox" }],
    ["4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt3", { type: "checkbox" }],
    ["4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt4", { type: "checkbox" }],
    ["4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt5", { type: "checkbox" }],
    ["4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt6", { type: "checkbox" }],
    ["4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt7", { type: "checkbox" }],
    ["4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt8", { type: "checkbox" }],
    ["4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt9", { type: "checkbox" }],
    ["4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt10", { type: "checkbox", showBorder: true }],
]);

export const Aneurisma: Map<string, ConfirmationData> = new Map([
    ["5576e7ed-351d-4a05-90fb-3e10a6b89cdc", { fontWeight: "bold" }],
    ["5576e7ed-351d-4a05-90fb-3e10a6b89cdc|23b1c9b2-bc0e-4a3f-ab04-21ae4c85e400", {}],
    ["5576e7ed-351d-4a05-90fb-3e10a6b89cdc|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["5576e7ed-351d-4a05-90fb-3e10a6b89cdc|f4ba857c-663d-4028-80db-97e830e29818", {}],
    ["5576e7ed-351d-4a05-90fb-3e10a6b89cdc|9f43f4ca-4fbc-414b-b26a-9d7b9a12211e", {}],
    ["5576e7ed-351d-4a05-90fb-3e10a6b89cdc|858365c8-0816-4c48-aac3-afc8d68d026f", {}],
    ["5576e7ed-351d-4a05-90fb-3e10a6b89cdc|2bfb5420-9ddb-4cc8-a37b-3e39ecfe4bbf", {}],
    ["5576e7ed-351d-4a05-90fb-3e10a6b89cdc|73a10aab-a474-4408-bb8c-145109087a4f", { type: "download", showBorder: true }],
])

export const AtaqueIsquemicoTransitorio: Map<string, ConfirmationData> = new Map([
    ["fdea0189-a52b-4f8e-85d1-57f2301c3062", { fontWeight: "bold" }],
    ["fdea0189-a52b-4f8e-85d1-57f2301c3062|493d650f-7d8a-4748-add7-627d0a69b1fa", {}],
    ["fdea0189-a52b-4f8e-85d1-57f2301c3062|8788c321-6206-427a-9d88-20edaecdfacc", {}],
    ["fdea0189-a52b-4f8e-85d1-57f2301c3062|4c24549c-6916-48c6-9b5a-a2cb7c7cbfca", { showBorder: true }],
])

export const AccidenteCerebrovascular: Map<string, ConfirmationData> = new Map([
    ["876d5773-fff7-45bb-a8f0-bbdb4e05f93e", { fontWeight: "bold" }],
    ["876d5773-fff7-45bb-a8f0-bbdb4e05f93e|493d650f-7d8a-4748-add7-627d0a69b1fa", {}],
    ["876d5773-fff7-45bb-a8f0-bbdb4e05f93e|8788c321-6206-427a-9d88-20edaecdfacc", {}],
    ["876d5773-fff7-45bb-a8f0-bbdb4e05f93e|4c24549c-6916-48c6-9b5a-a2cb7c7cbfca", { showBorder: true }],
])

export const EnfermedadValvular: Map<string, ConfirmationData> = new Map([
    ["f998cad8-35f6-4228-ab0a-f9feede59161", { fontWeight: "bold" }],
    ["f998cad8-35f6-4228-ab0a-f9feede59161|b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["f998cad8-35f6-4228-ab0a-f9feede59161|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["f998cad8-35f6-4228-ab0a-f9feede59161|f4ba857c-663d-4028-80db-97e830e29818", {}],
    ["f998cad8-35f6-4228-ab0a-f9feede59161|9f43f4ca-4fbc-414b-b26a-9d7b9a12211e", {}],
    ["f998cad8-35f6-4228-ab0a-f9feede59161|858365c8-0816-4c48-aac3-afc8d68d026f", {}],
    ["f998cad8-35f6-4228-ab0a-f9feede59161|2bfb5420-9ddb-4cc8-a37b-3e39ecfe4bbf", {}],
    ["f998cad8-35f6-4228-ab0a-f9feede59161|47473f90-d1cb-4225-801c-07f30a89945a", { type: "download", showBorder: true }],
])

export const HipertensionPulmonarInsuficienciaCardiaca: Map<string, ConfirmationData> = new Map([
    ["ee724566-5360-4858-a034-c37fe536e7a5", { fontWeight: "bold" }],
    ["ee724566-5360-4858-a034-c37fe536e7a5|b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["ee724566-5360-4858-a034-c37fe536e7a5|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["ee724566-5360-4858-a034-c37fe536e7a5|f4ba857c-663d-4028-80db-97e830e29818", {}],
    ["ee724566-5360-4858-a034-c37fe536e7a5|9f43f4ca-4fbc-414b-b26a-9d7b9a12211e", {}],
    ["ee724566-5360-4858-a034-c37fe536e7a5|858365c8-0816-4c48-aac3-afc8d68d026f", {}],
    ["ee724566-5360-4858-a034-c37fe536e7a5|2bfb5420-9ddb-4cc8-a37b-3e39ecfe4bbf", {}],
    ["ee724566-5360-4858-a034-c37fe536e7a5|8e0d0654-7dea-44e8-ae3b-6b9777f4ecf4", { type: "download", showBorder: true }],
])

export const OtrosCardiovascular: Map<string, ConfirmationData> = new Map([
    ["22988d08-6827-4a1d-bbf7-7818313773b5", { fontWeight: "bold" }],
    ["22988d08-6827-4a1d-bbf7-7818313773b5|b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["22988d08-6827-4a1d-bbf7-7818313773b5|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["22988d08-6827-4a1d-bbf7-7818313773b5|f4ba857c-663d-4028-80db-97e830e29818", {}],
    ["22988d08-6827-4a1d-bbf7-7818313773b5|9f43f4ca-4fbc-414b-b26a-9d7b9a12211e", {}],
    ["22988d08-6827-4a1d-bbf7-7818313773b5|858365c8-0816-4c48-aac3-afc8d68d026f", {}],
    ["22988d08-6827-4a1d-bbf7-7818313773b5|2bfb5420-9ddb-4cc8-a37b-3e39ecfe4bbf", {}],
    ["22988d08-6827-4a1d-bbf7-7818313773b5|8e0d0654-7dea-44e8-ae3b-6b9777f4ecf4", { type: "download", showBorder: true }],
])

export const PresionArterialAlta: Map<string, ConfirmationData> = new Map([
    ["7f90a967-9234-4f90-852c-f79aa7173024", { fontWeight: "bold" }],
    ["7f90a967-9234-4f90-852c-f79aa7173024|bab911ac-adde-4e1c-bf65-1157902c661d", {}],
    ["7f90a967-9234-4f90-852c-f79aa7173024|2f57de00-3d23-440b-8edd-267f5ea5a7a2", {}],
    ["7f90a967-9234-4f90-852c-f79aa7173024|37a86562-8120-4fad-bd1d-83550c421564", {}],
    ["7f90a967-9234-4f90-852c-f79aa7173024|047d6d7b-6c40-41d3-9271-0b5300da7855", {}],
    ["7f90a967-9234-4f90-852c-f79aa7173024|f028bbc1-dd86-4d22-99e4-b8ddd56f39b0", { showBorder: true }],
])

export const ColesterolTrigliceridos: Map<string, ConfirmationData> = new Map([
    ["25f1f1e9-3b2c-4e6a-a5dd-5cc168442044", { fontWeight: "bold" }],
    ["25f1f1e9-3b2c-4e6a-a5dd-5cc168442044|bab911ac-adde-4e1c-bf65-1157902c661d", {}],
    ["25f1f1e9-3b2c-4e6a-a5dd-5cc168442044|4d32fa23-972a-4929-98d5-38dbcfd8c7ef", {}],
    ["25f1f1e9-3b2c-4e6a-a5dd-5cc168442044|7f19be85-37ed-4c7e-9626-584e59e9c381", {}],
    ["25f1f1e9-3b2c-4e6a-a5dd-5cc168442044|30632690-669e-4906-b99c-939ea9d4d52c", {}],
    ["25f1f1e9-3b2c-4e6a-a5dd-5cc168442044|dc86cec7-4400-47ae-9374-94383b009afb", {}],
    ["25f1f1e9-3b2c-4e6a-a5dd-5cc168442044|047d6d7b-6c40-41d3-9271-0b5300da7855", {}],
    ["25f1f1e9-3b2c-4e6a-a5dd-5cc168442044|f028bbc1-dd86-4d22-99e4-b8ddd56f39b0", { showBorder: true }],
])

export const DolorToracicoBypass: Map<string, ConfirmationData> = new Map([
    ["9ad91294-b072-4634-a0ac-9d496dea2286", { fontWeight: "bold" }],
    ["9ad91294-b072-4634-a0ac-9d496dea2286|b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["08904b10-33c8-44a3-81ee-7ea2ad02da7d", {}],
    ["9ad91294-b072-4634-a0ac-9d496dea2286|16a0f768-e6af-43ae-82e2-ad9df584824a", {}],
    ["9ad91294-b072-4634-a0ac-9d496dea2286|9f43f4ca-4fbc-414b-b26a-9d7b9a12211e", {}],
    ["9ad91294-b072-4634-a0ac-9d496dea2286|858365c8-0816-4c48-aac3-afc8d68d026f", {}],
    ["9ad91294-b072-4634-a0ac-9d496dea2286|2bfb5420-9ddb-4cc8-a37b-3e39ecfe4bbf", {}],
    ["9ad91294-b072-4634-a0ac-9d496dea2286|f4ba857c-663d-4028-80db-97e830e29818", {}],
    ["9ad91294-b072-4634-a0ac-9d496dea2286|a0eff7d2-3313-48c9-aa4b-77be0daa8d65", { type: "download" }],
    ["9ad91294-b072-4634-a0ac-9d496dea2286|b8c7b34b-35ae-4536-9f69-04c3cc19a082", { type: "download", showBorder: true }],
])

export const EnfermedadVenasArterias: Map<string, ConfirmationData> = new Map([
    ["030a57f7-0006-4045-bc42-8363b4efe52f", { fontWeight: "bold" }],
    ["030a57f7-0006-4045-bc42-8363b4efe52f|b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["030a57f7-0006-4045-bc42-8363b4efe52f|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["030a57f7-0006-4045-bc42-8363b4efe52f|f4ba857c-663d-4028-80db-97e830e29818", {}],
    ["030a57f7-0006-4045-bc42-8363b4efe52f|9f43f4ca-4fbc-414b-b26a-9d7b9a12211e", {}],
    ["030a57f7-0006-4045-bc42-8363b4efe52f|858365c8-0816-4c48-aac3-afc8d68d026f", {}],
    ["030a57f7-0006-4045-bc42-8363b4efe52f|2bfb5420-9ddb-4cc8-a37b-3e39ecfe4bbf", {}],
    ["030a57f7-0006-4045-bc42-8363b4efe52f|810027cb-8d9b-4952-9786-e79f0976fcc4", { type: "download", showBorder: true }],
])

export const ArritmiaMarcapasos: Map<string, ConfirmationData> = new Map([
    ["c9cf2181-bb2c-4fdb-82c2-ad78a0200dbd", { fontWeight: "bold" }],
    ["c9cf2181-bb2c-4fdb-82c2-ad78a0200dbd|b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["c9cf2181-bb2c-4fdb-82c2-ad78a0200dbd|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["c9cf2181-bb2c-4fdb-82c2-ad78a0200dbd|f4ba857c-663d-4028-80db-97e830e29818", {}],
    ["c9cf2181-bb2c-4fdb-82c2-ad78a0200dbd|9f43f4ca-4fbc-414b-b26a-9d7b9a12211e", {}],
    ["c9cf2181-bb2c-4fdb-82c2-ad78a0200dbd|858365c8-0816-4c48-aac3-afc8d68d026f", {}],
    ["c9cf2181-bb2c-4fdb-82c2-ad78a0200dbd|2bfb5420-9ddb-4cc8-a37b-3e39ecfe4bbf", {}],
    ["c9cf2181-bb2c-4fdb-82c2-ad78a0200dbd|9b8214ef-fe4d-4ea4-aa49-41692c3ae15e", { type: "download", showBorder: true }],
])

const respiratoryDisordersInfo = new Map<string, ConfirmationData>([
    ["b1afea9a-7bc4-4ec2-b593-df05ec12d92e", { fontWeight: "bold", color: "skyblue" }],
    ["db9b7624-fb4d-419b-8389-178d61c03d83", { fontWeight: "bold" }],
    ["e66d0bf8-12f3-440e-b0a3-165aacb69966-opt0", { type: "checkbox" }],
    ["e66d0bf8-12f3-440e-b0a3-165aacb69966-opt1", { type: "checkbox" }],
    ["e66d0bf8-12f3-440e-b0a3-165aacb69966-opt2", { type: "checkbox" }],
    ["e66d0bf8-12f3-440e-b0a3-165aacb69966-opt3", { type: "checkbox" }],
    ["e66d0bf8-12f3-440e-b0a3-165aacb69966-opt4", { type: "checkbox" }],
    ["e66d0bf8-12f3-440e-b0a3-165aacb69966-opt5", { type: "checkbox" }],
    ["e66d0bf8-12f3-440e-b0a3-165aacb69966-opt6", { type: "checkbox", showBorder: true }],
]);

export const AsmaInfo: Map<string, ConfirmationData> = new Map([
    ["0c86d269-7b41-46b3-a0f3-c60858fa3455", { fontWeight: "bold" }],
    ["0c86d269-7b41-46b3-a0f3-c60858fa3455|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["0c86d269-7b41-46b3-a0f3-c60858fa3455|8743861d-d059-457f-a8d1-59e69ab1507d", {}],
    ["0c86d269-7b41-46b3-a0f3-c60858fa3455|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["0c86d269-7b41-46b3-a0f3-c60858fa3455|777f6c37-3021-44aa-a5c2-d31a7efac273", {}],
    ["0c86d269-7b41-46b3-a0f3-c60858fa3455|19d8448c-da8d-4a52-ac57-a86e849359e2", {}],
    ["0c86d269-7b41-46b3-a0f3-c60858fa3455|fcb6db1a-53e6-4ceb-9314-1e807dbaccde", { showBorder: true }],
])

export const EPOCInfo: Map<string, ConfirmationData> = new Map([
    ["82d741c0-a1be-4b50-b03a-cd3b48620978", { fontWeight: "bold" }],
    ["82d741c0-a1be-4b50-b03a-cd3b48620978|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["82d741c0-a1be-4b50-b03a-cd3b48620978|8743861d-d059-457f-a8d1-59e69ab1507d", {}],
    ["82d741c0-a1be-4b50-b03a-cd3b48620978|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["82d741c0-a1be-4b50-b03a-cd3b48620978|777f6c37-3021-44aa-a5c2-d31a7efac273", {}],
    ["82d741c0-a1be-4b50-b03a-cd3b48620978|19d8448c-da8d-4a52-ac57-a86e849359e2", { showBorder: true }],
]);

export const EnfisemaInfo: Map<string, ConfirmationData> = new Map([
    ["cf31fe6b-6b2c-424d-8033-48572bfdc949", { fontWeight: "bold" }],
    ["cf31fe6b-6b2c-424d-8033-48572bfdc949|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["cf31fe6b-6b2c-424d-8033-48572bfdc949|8743861d-d059-457f-a8d1-59e69ab1507d", {}],
    ["cf31fe6b-6b2c-424d-8033-48572bfdc949|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["cf31fe6b-6b2c-424d-8033-48572bfdc949|777f6c37-3021-44aa-a5c2-d31a7efac273", {}],
    ["cf31fe6b-6b2c-424d-8033-48572bfdc949|19d8448c-da8d-4a52-ac57-a86e849359e2", { showBorder: true }],
]);

export const FibrosisInfo: Map<string, ConfirmationData> = new Map([
    ["44cad008-403a-4e3a-ad68-759654c46570", { fontWeight: "bold" }],
    ["44cad008-403a-4e3a-ad68-759654c46570|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["44cad008-403a-4e3a-ad68-759654c46570|8743861d-d059-457f-a8d1-59e69ab1507d", {}],
    ["44cad008-403a-4e3a-ad68-759654c46570|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["44cad008-403a-4e3a-ad68-759654c46570|777f6c37-3021-44aa-a5c2-d31a7efac273", {}],
    ["44cad008-403a-4e3a-ad68-759654c46570|19d8448c-da8d-4a52-ac57-a86e849359e2", {}],
    ["44cad008-403a-4e3a-ad68-759654c46570|fcb6db1a-53e6-4ceb-9314-1e807dbaccde", { showBorder: true }],
]);

export const BronquitisCronicaInfo: Map<string, ConfirmationData> = new Map([
    ["a5bad78d-1341-4c17-a17c-0c8e85a72f2a", { fontWeight: "bold" }],
    ["a5bad78d-1341-4c17-a17c-0c8e85a72f2a|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["a5bad78d-1341-4c17-a17c-0c8e85a72f2a|8743861d-d059-457f-a8d1-59e69ab1507d", {}],
    ["a5bad78d-1341-4c17-a17c-0c8e85a72f2a|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["a5bad78d-1341-4c17-a17c-0c8e85a72f2a|777f6c37-3021-44aa-a5c2-d31a7efac273", {}],
    ["a5bad78d-1341-4c17-a17c-0c8e85a72f2a|19d8448c-da8d-4a52-ac57-a86e849359e2", {}],
    ["a5bad78d-1341-4c17-a17c-0c8e85a72f2a|fcb6db1a-53e6-4ceb-9314-1e807dbaccde", { showBorder: true }],
]);

export const ApneaSuenoInfo: Map<string, ConfirmationData> = new Map([
    ["0802e908-dd54-4658-8709-88b18b7b3b8e", { fontWeight: "bold" }],
    ["0802e908-dd54-4658-8709-88b18b7b3b8e|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["0802e908-dd54-4658-8709-88b18b7b3b8e|8743861d-d059-457f-a8d1-59e69ab1507d", {}],
    ["0802e908-dd54-4658-8709-88b18b7b3b8e|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["0802e908-dd54-4658-8709-88b18b7b3b8e|777f6c37-3021-44aa-a5c2-d31a7efac273", {}],
    ["0802e908-dd54-4658-8709-88b18b7b3b8e|19d8448c-da8d-4a52-ac57-a86e849359e2", { showBorder: true }],
]);

export const OtrosRespiratoriosInfo: Map<string, ConfirmationData> = new Map([
    ["fcf82b0a-d8ee-45d1-98f0-46a19bf1e394", { fontWeight: "bold" }],
    ["fcf82b0a-d8ee-45d1-98f0-46a19bf1e394|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["fcf82b0a-d8ee-45d1-98f0-46a19bf1e394|8743861d-d059-457f-a8d1-59e69ab1507d", {}],
    ["fcf82b0a-d8ee-45d1-98f0-46a19bf1e394|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["fcf82b0a-d8ee-45d1-98f0-46a19bf1e394|777f6c37-3021-44aa-a5c2-d31a7efac273", {}],
    ["fcf82b0a-d8ee-45d1-98f0-46a19bf1e394|fcb6db1a-53e6-4ceb-9314-1e807dbaccde", {}],
    ["fcf82b0a-d8ee-45d1-98f0-46a19bf1e394|19d8448c-da8d-4a52-ac57-a86e849359e2", { showBorder: true }],

]);

export const hospitalizedForRespiratoryIllness: Map<string, ConfirmationData> = new Map([
    ["6e742436-3fb5-4a48-baa1-6a14da69d1d0", { fontWeight: "bold" }],
])

export const RespiratoryIllnessHospitalizations: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Hospitalización", fontWeight: "bold" }],
    ["6f35e3e8-e182-4ce0-9290-8d57600c9eb7", {}],
    ["06e6a9ac-44f2-481b-b4c9-6efb7288624b", {}],
    ["c70d99ab-b20b-4169-a0de-33269ea4fa85", {}],
    ["05c91555-1877-4e9f-842d-2956fd7cd2db", { showBorder: true }],
]);

export const RespiratoryIllnessTreatments: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Tratamiento", fontWeight: "bold" }],
    ["2cb81471-25fc-418c-b6e0-2dd86af9aadc", {}],
    ["598c76c5-ae48-47cb-92e3-62cfb36a0810", {}],
    ["f71537b2-4802-4999-bb68-ad1265658576", {}],
    ["2d94172d-d2a1-4e12-b066-f80dd4e84065", {}],
    ["238f0c3b-a5b9-461c-a617-a6e67597a90a", { showBorder: true }],
]);

export const respiratoryExamForThisCondition: Map<string, ConfirmationData> = new Map([
    ["6efe9ebc-13b3-4739-8615-6adf2a013bd5", { fontWeight: "bold" }],
])

export const respiratoryExams: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Examen", fontWeight: "bold" }],
    ["42a1860e-3831-4a2e-8fe8-defedefbc791", {}],
    ["effab412-6434-4f63-a211-e4b869b475d3", {}],
    ["e671dc70-ddd5-4396-bd6a-853d3a186335", {}],
    ["05c91555-1877-4e9f-842d-2956fd7cd2db", { showBorder: true }],
])

export const peakFlowMeterRespiratory: Map<string, ConfirmationData> = new Map([
    ["32372f90-16df-4f7c-9c87-cf4b9419415a", { fontWeight: "bold" }],
])

export const peakFlowMeterRespiratoryInformation: Map<string, ConfirmationData> = new Map([
    ["de0b5b9a-a744-46eb-b24e-b6c7f29facb1|5fa44418-09d8-451c-950e-6cad1fc95818", {}],
    ["de0b5b9a-a744-46eb-b24e-b6c7f29facb1|cea630b1-f8ff-4acd-ab0f-b20dc99603d5", {}],
    ["de0b5b9a-a744-46eb-b24e-b6c7f29facb1|3e6c611b-0bea-4bd7-b919-3eeb1cdf23c3", { showBorder: true }],
])

export const specialistReview: Map<string, ConfirmationData> = new Map([
    ["51a1c669-113d-402c-9134-981764ea56ad", { fontWeight: "bold" }],
])

export const specialistInfo: Map<string, ConfirmationData> = new Map([
    ["5ae231c5-3bfa-4629-a7d8-26f872615c9f|f71537b2-4802-4999-bb68-ad1265658576", {}],
    ["5ae231c5-3bfa-4629-a7d8-26f872615c9f|05c91555-1877-4e9f-842d-2956fd7cd2db", {}],
])

export const restrictedActivities: Map<string, ConfirmationData> = new Map([
    ["418709fb-bcf4-411e-8e9d-2098c7d63cc3", { fontWeight: "bold" }],
])

export const restrictedActivitiesInfo: Map<string, ConfirmationData> = new Map([
    ["483f9c30-48a2-4816-9be0-74ba0c3d57d4|15d8190b-2248-4f36-a176-701f53a0bb05", {}],
    ["483f9c30-48a2-4816-9be0-74ba0c3d57d4|87187bc2-7a0b-4f43-85ac-a8e872b90ac0", {}],
    ["483f9c30-48a2-4816-9be0-74ba0c3d57d4|238f0c3b-a5b9-461c-a617-a6e67597a90a", { showBorder: true }],
])

export const cancerDiagnosticInfo: Map<string, ConfirmationData> = new Map([
    ["3bc73995-a6c5-40cf-a3cc-6866f683912d", { fontWeight: "bold", color: "skyblue" }],
    ["dea802e4-411a-4a7a-a5af-f9fe9be4ab55", { fontWeight: "bold" }],
    ["b9048f81-20d9-4b75-bed6-e6550732d98a|b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["b9048f81-20d9-4b75-bed6-e6550732d98a|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["b9048f81-20d9-4b75-bed6-e6550732d98a|f1fce74e-f51a-44ee-95dc-d31cda067b04", { showBorder: true }],
    ["429a6263-281e-43a4-a901-2e2414d060e2", { fontWeight: "bold" }],
    ["1bb538a0-a29e-4fdc-8cf4-2415f71d6213-opt0", { type: "checkbox" }],
    ["1bb538a0-a29e-4fdc-8cf4-2415f71d6213-opt1", { type: "checkbox" }],
    ["1bb538a0-a29e-4fdc-8cf4-2415f71d6213-opt2", { type: "checkbox" }],
    ["1bb538a0-a29e-4fdc-8cf4-2415f71d6213-opt3", { type: "checkbox", showBorder: true }],
])

export const cancerQuimioterapia: Map<string, ConfirmationData> = new Map([
    ["11718e67-4ec8-440e-9c8e-10264a77d3d2", { fontWeight: "bold" }],
    ["11718e67-4ec8-440e-9c8e-10264a77d3d2|7ad84f6e-be8f-4e13-a489-ba71e558b6eb", {}],
    ["11718e67-4ec8-440e-9c8e-10264a77d3d2|4481adc6-5fed-4e4e-b205-e2d009de3cc1", {}],
    ["11718e67-4ec8-440e-9c8e-10264a77d3d2|2cb81471-25fc-418c-b6e0-2dd86af9aadc", {}],
    ["11718e67-4ec8-440e-9c8e-10264a77d3d2|598c76c5-ae48-47cb-92e3-62cfb36a0810", { showBorder: true }],
])
export const cancerRadioterapia: Map<string, ConfirmationData> = new Map([
    ["65564e68-0027-4aa9-9546-deb849bd62ef", { fontWeight: "bold" }],
    ["65564e68-0027-4aa9-9546-deb849bd62ef|7ad84f6e-be8f-4e13-a489-ba71e558b6eb", {}],
    ["65564e68-0027-4aa9-9546-deb849bd62ef|4481adc6-5fed-4e4e-b205-e2d009de3cc1", {}],
    ["65564e68-0027-4aa9-9546-deb849bd62ef|2cb81471-25fc-418c-b6e0-2dd86af9aadc", {}],
    ["65564e68-0027-4aa9-9546-deb849bd62ef|598c76c5-ae48-47cb-92e3-62cfb36a0810", { showBorder: true }],
])

export const cancerMonitoreo: Map<string, ConfirmationData> = new Map([
    ["8a5cb439-0cca-4886-992c-40b195d7bbf6", { fontWeight: "bold" }],
    ["8a5cb439-0cca-4886-992c-40b195d7bbf6|7ad84f6e-be8f-4e13-a489-ba71e558b6eb", {}],
    ["8a5cb439-0cca-4886-992c-40b195d7bbf6|4481adc6-5fed-4e4e-b205-e2d009de3cc1", {}],
    ["8a5cb439-0cca-4886-992c-40b195d7bbf6|2cb81471-25fc-418c-b6e0-2dd86af9aadc", {}],
    ["8a5cb439-0cca-4886-992c-40b195d7bbf6|598c76c5-ae48-47cb-92e3-62cfb36a0810", { showBorder: true }],
])

export const cancerOtrosMedicamentos: Map<string, ConfirmationData> = new Map([
    ["c5bb3ee8-853a-46ce-bf46-4e12110a4607", { fontWeight: "bold" }],
    ["c5bb3ee8-853a-46ce-bf46-4e12110a4607|2cb81471-25fc-418c-b6e0-2dd86af9aadc", {}],
    ["c5bb3ee8-853a-46ce-bf46-4e12110a4607|598c76c5-ae48-47cb-92e3-62cfb36a0810", { showBorder: true }],
    ["c5bb3ee8-853a-46ce-bf46-4e12110a4607|980fd863-39a6-4854-a45f-adc7cf71dab9", { type: "download", showBorder: true }],
    ["c5bb3ee8-853a-46ce-bf46-4e12110a4607|980fd863-39a6-4854-a45f-adc7cf71dab9", { type: "download", showBorder: true }],
])



export const surgeryOrBiopsy: Map<string, ConfirmationData> = new Map([
    ["02af736d-f315-4ea8-b4a5-d16783e855ed", { fontWeight: "bold" }],
])

export const surgeries: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Cirugía", fontWeight: "bold" }],
    ["785012b7-7efd-4574-9bb2-a900a5790f53", {}],
    ["2bfb5420-9ddb-4cc8-a37b-3e39ecfe4bbf", {}],
    ["f353dcf0-1ffb-4826-83ce-2e4a5bb14d11", { type: "download", showBorder: true }],
])

export const DiabetesInfo: Map<string, ConfirmationData> = new Map([
    ["2af27904-7a74-43e4-957f-f1d48b0a6bb4", { fontWeight: "bold", color: "skyblue" }],
    ["4e1ec11e-4e0a-4a78-b2f4-c20241038ef0", { fontWeight: "bold" }],
    ["0d739a14-3501-4363-8603-9d285b1f118e-opt1", { type: "checkbox" }],
    ["0d739a14-3501-4363-8603-9d285b1f118e-opt2", { type: "checkbox" }],
    ["0d739a14-3501-4363-8603-9d285b1f118e-opt3", { type: "checkbox" }],
    ["0d739a14-3501-4363-8603-9d285b1f118e-opt4", { type: "checkbox" }],
    ["0d739a14-3501-4363-8603-9d285b1f118e-opt5", { type: "checkbox", showBorder: true }]
])

export const DiabetesAlteracionGlucosa: Map<string, ConfirmationData> = new Map([
    ["cfb0df47-b851-45e1-b80e-b2d0d82aeaba", { fontWeight: "bold" }],
    ["cfb0df47-b851-45e1-b80e-b2d0d82aeaba|515298c0-ff59-4752-badf-7924d58470e2", {}],
    ["cfb0df47-b851-45e1-b80e-b2d0d82aeaba|bab911ac-adde-4e1c-bf65-1157902c661d", {}],
    ["cfb0df47-b851-45e1-b80e-b2d0d82aeaba|6c5178f9-f582-49f1-9a91-a6fbf54b97b2", {}],
    ["cfb0df47-b851-45e1-b80e-b2d0d82aeaba|6fed6fe0-9ef5-4938-928a-cdbe6fbd474d", {}],
    ["cfb0df47-b851-45e1-b80e-b2d0d82aeaba|980fd863-39a6-4854-a45f-adc7cf71dab9", { type: "download", showBorder: true }],
])

export const adrenalDisorders: Map<string, ConfirmationData> = new Map([
    ["2f62f9d3-aa3f-46fe-a93e-a1c9bb1f4f97", { fontWeight: "bold" }],
    ["2f62f9d3-aa3f-46fe-a93e-a1c9bb1f4f97|b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["2f62f9d3-aa3f-46fe-a93e-a1c9bb1f4f97|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["2f62f9d3-aa3f-46fe-a93e-a1c9bb1f4f97|f1fce74e-f51a-44ee-95dc-d31cda067b04", {}],
    ["2f62f9d3-aa3f-46fe-a93e-a1c9bb1f4f97|047d6d7b-6c40-41d3-9271-0b5300da7855", {}],
    ["2f62f9d3-aa3f-46fe-a93e-a1c9bb1f4f97|598c76c5-ae48-47cb-92e3-62cfb36a0810", {}],
    ["2f62f9d3-aa3f-46fe-a93e-a1c9bb1f4f97|e5f4bb51-5551-4b77-8ac3-e3c1a6aa10e1", { type: "download", showBorder: true }],
])

export const urineAbnormalResults: Map<string, ConfirmationData> = new Map([
    ["a532c924-9d90-4f5d-8904-379f457b300a", { fontWeight: "bold" }],
])

export const urineAbnormalResultsInfo: Map<string, ConfirmationData> = new Map([
    ["1bbee43d-259d-408e-a641-d2d5ad117c95|238f0c3b-a5b9-461c-a617-a6e67597a90a", {}],
    ["1bbee43d-259d-408e-a641-d2d5ad117c95|980fd863-39a6-4854-a45f-adc7cf71dab9", { type: "download", showBorder: true }],
])

export const DigestiveSystem: Map<string, ConfirmationData> = new Map([
    ["c7ce1d4c-5f05-4a77-9241-f6b3cb8ed585", { lfontWeight: "bold", color: "skyblue" }],
    ["83de4129-35ad-449d-81cd-83e072e0eb86", { fontWeight: "bold" }],
    ["715a5ed4-9011-4064-97f2-52b0e17f1ca2-opt1", { type: "checkbox" }],
    ["715a5ed4-9011-4064-97f2-52b0e17f1ca2-opt2", { type: "checkbox" }],
    ["715a5ed4-9011-4064-97f2-52b0e17f1ca2-opt3", { type: "checkbox" }],
    ["715a5ed4-9011-4064-97f2-52b0e17f1ca2-opt4", { type: "checkbox" }],
    ["715a5ed4-9011-4064-97f2-52b0e17f1ca2-opt5", { type: "checkbox" }],
    ["715a5ed4-9011-4064-97f2-52b0e17f1ca2-opt6", { type: "checkbox", showBorder: true }]
])

export const Esophagus: Map<string, ConfirmationData> = new Map([
    ["ce43b958-b1df-41c1-a37b-3e8ba19f89e1", { fontWeight: "bold" }],
    ["ce43b958-b1df-41c1-a37b-3e8ba19f89e1|b758222a-506e-4571-9fb8-2dee27de880f", { fontWeight: "bold" }],
    ["ce43b958-b1df-41c1-a37b-3e8ba19f89e1|c1e0db0d-4d06-4638-bdde-79a9703842d1", { fontWeight: "bold" }],
    ["ce43b958-b1df-41c1-a37b-3e8ba19f89e1|f1fce74e-f51a-44ee-95dc-d31cda067b04", { fontWeight: "bold", showBorder: true }],
])

export const Stomach: Map<string, ConfirmationData> = new Map([
    ["b9200276-bdda-469c-9c16-fa0cec2d3680", { fontWeight: "bold" }],
    ["b9200276-bdda-469c-9c16-fa0cec2d3680|b758222a-506e-4571-9fb8-2dee27de880f", { fontWeight: "bold" }],
    ["b9200276-bdda-469c-9c16-fa0cec2d3680|c1e0db0d-4d06-4638-bdde-79a9703842d1", { fontWeight: "bold" }],
    ["b9200276-bdda-469c-9c16-fa0cec2d3680|f1fce74e-f51a-44ee-95dc-d31cda067b04", { fontWeight: "bold", showBorder: true }],
])

export const Liver: Map<string, ConfirmationData> = new Map([
    ["d0322665-69f8-4cc9-aa47-451d3f08e6c5", { fontWeight: "bold" }],
    ["d0322665-69f8-4cc9-aa47-451d3f08e6c5|b758222a-506e-4571-9fb8-2dee27de880f", { fontWeight: "bold" }],
    ["d0322665-69f8-4cc9-aa47-451d3f08e6c5|c1e0db0d-4d06-4638-bdde-79a9703842d1", { fontWeight: "bold" }],
    ["d0322665-69f8-4cc9-aa47-451d3f08e6c5|f1fce74e-f51a-44ee-95dc-d31cda067b04", { fontWeight: "bold", showBorder: true }],
])

export const Gallbladder: Map<string, ConfirmationData> = new Map([
    ["17d23769-09e2-45bb-b61a-b1e2e341b8b3", { fontWeight: "bold" }],
    ["17d23769-09e2-45bb-b61a-b1e2e341b8b3|b758222a-506e-4571-9fb8-2dee27de880f", { fontWeight: "bold" }],
    ["17d23769-09e2-45bb-b61a-b1e2e341b8b3|c1e0db0d-4d06-4638-bdde-79a9703842d1", { fontWeight: "bold" }],
    ["17d23769-09e2-45bb-b61a-b1e2e341b8b3|f1fce74e-f51a-44ee-95dc-d31cda067b04", { fontWeight: "bold", showBorder: true }],
])

export const Pancreas: Map<string, ConfirmationData> = new Map([
    ["a3275c18-b618-4a2a-93ef-d7453db2e86e", { fontWeight: "bold" }],
    ["a3275c18-b618-4a2a-93ef-d7453db2e86e|b758222a-506e-4571-9fb8-2dee27de880f", { fontWeight: "bold" }],
    ["a3275c18-b618-4a2a-93ef-d7453db2e86e|c1e0db0d-4d06-4638-bdde-79a9703842d1", { fontWeight: "bold" }],
    ["a3275c18-b618-4a2a-93ef-d7453db2e86e|f1fce74e-f51a-44ee-95dc-d31cda067b04", { fontWeight: "bold", showBorder: true }],
])

export const Intestines: Map<string, ConfirmationData> = new Map([
    ["00ab9a56-622e-4d9e-b47f-a0ebc02bacdb", { fontWeight: "bold" }],
    ["00ab9a56-622e-4d9e-b47f-a0ebc02bacdb|b758222a-506e-4571-9fb8-2dee27de880f", { fontWeight: "bold" }],
    ["00ab9a56-622e-4d9e-b47f-a0ebc02bacdb|c1e0db0d-4d06-4638-bdde-79a9703842d1", { fontWeight: "bold" }],
    ["00ab9a56-622e-4d9e-b47f-a0ebc02bacdb|f1fce74e-f51a-44ee-95dc-d31cda067b04", { fontWeight: "bold", showBorder: true }],
])

export const DigestiveSystemTreatment: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Tratamiento", fontWeight: "bold" }],
    ["2cb81471-25fc-418c-b6e0-2dd86af9aadc", { fontWeight: "bold" }],
    ["598c76c5-ae48-47cb-92e3-62cfb36a0810", { fontWeight: "bold" }],
    ["f76f697f-80e4-4c0c-8f80-1289683898ae", { fontWeight: "bold" }],
    ["fd236fa1-e378-4088-be6e-31eb4e0ba363", { fontWeight: "bold", showBorder: true }],
])

export const DigestiveSystem2: Map<string, ConfirmationData> = new Map([
    ["f30fe94a-0894-4422-9137-6b4f08dd763a|361f99aa-f3b6-474a-9974-0e9173177596", { type: "download", showBorder: true }],
])


export const NeurologicalDisorders: Map<string, ConfirmationData> = new Map([
    ["06be1718-5f05-4606-89ac-e6fbb4014236", { fontWeight: "bold", color: "skyblue" }],
    ["32499197-b06d-4d06-ba66-c914fabaec95", { fontWeight: "bold" }],
    ["87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt1", { type: "checkbox" }],
    ["87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt2", { type: "checkbox" }],
    ["87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt3", { type: "checkbox" }],
    ["87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt4", { type: "checkbox" }],
    ["87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt5", { type: "checkbox" }],
    ["87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt6", { type: "checkbox" }],
    ["87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt7", { type: "checkbox", showBorder: true }]
])

export const Convulsiones: Map<string, ConfirmationData> = new Map([
    ["d90860c5-381d-48da-a527-53c35e90add5", { fontWeight: "bold" }],
    ["d90860c5-381d-48da-a527-53c35e90add5|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["d90860c5-381d-48da-a527-53c35e90add5|b0e3d871-18f6-4d7b-85d7-fd34b6c65b13", {}],
    ["d90860c5-381d-48da-a527-53c35e90add5|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["d90860c5-381d-48da-a527-53c35e90add5|e14de40d-b090-43fe-9187-8095785b2b9a", {}],
    ["d90860c5-381d-48da-a527-53c35e90add5|f71537b2-4802-4999-bb68-ad1265658576", { showBorder: true }],
])

export const FatigaCrónica: Map<string, ConfirmationData> = new Map([
    ["e56cd03a-857c-4e1e-9d43-00ba89617428", { fontWeight: "bold" }],
    ["e56cd03a-857c-4e1e-9d43-00ba89617428|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["e56cd03a-857c-4e1e-9d43-00ba89617428|b0e3d871-18f6-4d7b-85d7-fd34b6c65b13", {}],
    ["e56cd03a-857c-4e1e-9d43-00ba89617428|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["e56cd03a-857c-4e1e-9d43-00ba89617428|e14de40d-b090-43fe-9187-8095785b2b9a", {}],
    ["e56cd03a-857c-4e1e-9d43-00ba89617428|f71537b2-4802-4999-bb68-ad1265658576", { showBorder: true }],
])

export const Mareos: Map<string, ConfirmationData> = new Map([
    ["6aa5dbac-ff70-432a-b44b-a0e98458c589", { fontWeight: "bold" }],
    ["6aa5dbac-ff70-432a-b44b-a0e98458c589|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["6aa5dbac-ff70-432a-b44b-a0e98458c589|b0e3d871-18f6-4d7b-85d7-fd34b6c65b13", {}],
    ["6aa5dbac-ff70-432a-b44b-a0e98458c589|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["6aa5dbac-ff70-432a-b44b-a0e98458c589|e14de40d-b090-43fe-9187-8095785b2b9a", {}],
    ["6aa5dbac-ff70-432a-b44b-a0e98458c589|f71537b2-4802-4999-bb68-ad1265658576", { showBorder: true }],
])

export const Parálisis: Map<string, ConfirmationData> = new Map([
    ["437d3640-e1c6-44f2-b894-709bfcaa7ca2", { fontWeight: "bold" }],
    ["437d3640-e1c6-44f2-b894-709bfcaa7ca2|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["437d3640-e1c6-44f2-b894-709bfcaa7ca2|b0e3d871-18f6-4d7b-85d7-fd34b6c65b13", {}],
    ["437d3640-e1c6-44f2-b894-709bfcaa7ca2|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["437d3640-e1c6-44f2-b894-709bfcaa7ca2|e14de40d-b090-43fe-9187-8095785b2b9a", {}],
    ["437d3640-e1c6-44f2-b894-709bfcaa7ca2|f71537b2-4802-4999-bb68-ad1265658576", { showBorder: true }],
])

export const OtroTrastornoDelCerebro: Map<string, ConfirmationData> = new Map([
    ["1056dfab-bc6e-4217-ae0c-57710f75400f", { fontWeight: "bold" }],
    ["1056dfab-bc6e-4217-ae0c-57710f75400f|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["1056dfab-bc6e-4217-ae0c-57710f75400f|b0e3d871-18f6-4d7b-85d7-fd34b6c65b13", {}],
    ["1056dfab-bc6e-4217-ae0c-57710f75400f|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["1056dfab-bc6e-4217-ae0c-57710f75400f|e14de40d-b090-43fe-9187-8095785b2b9a", {}],
    ["1056dfab-bc6e-4217-ae0c-57710f75400f|f71537b2-4802-4999-bb68-ad1265658576", { showBorder: true }],
])

export const TrastornoDeLaMédulaEspinal: Map<string, ConfirmationData> = new Map([
    ["8ef422bf-7dd6-4811-9ebe-f0144fb6f352", { fontWeight: "bold" }],
    ["8ef422bf-7dd6-4811-9ebe-f0144fb6f352|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["8ef422bf-7dd6-4811-9ebe-f0144fb6f352|b0e3d871-18f6-4d7b-85d7-fd34b6c65b13", {}],
    ["8ef422bf-7dd6-4811-9ebe-f0144fb6f352|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["8ef422bf-7dd6-4811-9ebe-f0144fb6f352|e14de40d-b090-43fe-9187-8095785b2b9a", {}],
    ["8ef422bf-7dd6-4811-9ebe-f0144fb6f352|f71537b2-4802-4999-bb68-ad1265658576", { showBorder: true }],
])

export const OtroTrastornoNeurológico: Map<string, ConfirmationData> = new Map([
    ["40a1f5fd-0650-460e-a3a2-855dad1cfcdb", { fontWeight: "bold" }],
    ["40a1f5fd-0650-460e-a3a2-855dad1cfcdb|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["40a1f5fd-0650-460e-a3a2-855dad1cfcdb|b0e3d871-18f6-4d7b-85d7-fd34b6c65b13", {}],
    ["40a1f5fd-0650-460e-a3a2-855dad1cfcdb|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["40a1f5fd-0650-460e-a3a2-855dad1cfcdb|e14de40d-b090-43fe-9187-8095785b2b9a", {}],
    ["40a1f5fd-0650-460e-a3a2-855dad1cfcdb|f71537b2-4802-4999-bb68-ad1265658576", { showBorder: true }],
])

export const scannerNeurologicalDisorders: Map<string, ConfirmationData> = new Map([
    ["58c0fd3a-43e9-4b59-a4ea-f5814160582b", { fontWeight: "bold" }],
])

export const scannerNeurologicalDisordersInfo: Map<string, ConfirmationData> = new Map([
    ["5ae58730-6888-48fa-8e3a-5aaed6fcede5|980fd863-39a6-4854-a45f-adc7cf71dab9", { type: "download", showBorder: true }],
])

export const statusEpilepticus: Map<string, ConfirmationData> = new Map([
    ["dd6c14b2-387c-4be8-8263-134d3c8703a2", { fontWeight: "bold" }],
])

export const statusEpilepticusInfo: Map<string, ConfirmationData> = new Map([
    ["46a221b9-2878-48a5-870a-e6504c64f648|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["46a221b9-2878-48a5-870a-e6504c64f648|c70d99ab-b20b-4169-a0de-33269ea4fa85", { showBorder: true }],
])

export const statusEpilepticusInfo2: Map<string, ConfirmationData> = new Map([
    ["ff234cc7-87bb-45ea-9411-0c531d072421", { fontWeight: "bold" }],
])

export const NeurologicalDisordersTreatments: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Tratamiento", fontWeight: "bold" }],
    ["882a61e2-f700-4d14-aa77-7a2f17c9a8ce", {}],
    ["598c76c5-ae48-47cb-92e3-62cfb36a0810", {}],
    ["f71537b2-4802-4999-bb68-ad1265658576", { showBorder: true }],
])

export const NeurologicalDisordersOtherTreatmentsInfo: Map<string, ConfirmationData> = new Map([
    ["744fb3ec-3442-4d77-ac0d-42a1811d4b14", { fontWeight: "bold" }],
    ["8acfc197-7909-40d9-8ff4-7b182f2b3821|06bfc05d-864d-429a-817a-ee851fb1a37f", { showBorder: true }],
])

export const NeurologicalDisordersOtherTreatments: Map<string, ConfirmationData> = new Map([
    ["2d94172d-d2a1-4e12-b066-f80dd4e84065", { fontWeight: "bold" }],
])

export const NeurologicalDisordersTreatmentsInfo: Map<string, ConfirmationData> = new Map([
    ["a920565f-8e21-4ab0-9f0c-8752b138766e|06bfc05d-864d-429a-817a-ee851fb1a37f", { showBorder: true }],
])

export const statusEpilepticusHospitalization: Map<string, ConfirmationData> = new Map([
    ["a0fd74da-aebc-42dd-bff3-5175eb63133d", { fontWeight: "bold" }],
])

export const statusEpilepticusHospitalizationInfo: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Hospitalización ", fontWeight: "bold" }],
    ["6f35e3e8-e182-4ce0-9290-8d57600c9eb7", {}],
    ["06e6a9ac-44f2-481b-b4c9-6efb7288624b", {}],
    ["c70d99ab-b20b-4169-a0de-33269ea4fa85", {}],
    ["05c91555-1877-4e9f-842d-2956fd7cd2db", { showBorder: true }],
])

export const statusEpilepticusSupervision: Map<string, ConfirmationData> = new Map([
    ["10db1210-1744-498a-862e-81db744f6f44", { fontWeight: "bold" }],
])

export const statusEpilepticusSupervisionInfo: Map<string, ConfirmationData> = new Map([
    ["b748670b-346c-4cf4-9d5d-dc9bbc1f6d8d|05c91555-1877-4e9f-842d-2956fd7cd2db", {}],
    ["b748670b-346c-4cf4-9d5d-dc9bbc1f6d8d|f71537b2-4802-4999-bb68-ad1265658576", { showBorder: true }],
])

export const driverLicenseRestriction: Map<string, ConfirmationData> = new Map([
    ["903532d1-bc43-4e64-8ffb-0069534fa03e", { fontWeight: "bold" }],
])

export const driverLicenseRestrictionInfo: Map<string, ConfirmationData> = new Map([
    ["2d869ae6-f3f5-4581-aee3-9a6e3a9365fc|cf11d14c-7f27-415c-a809-e0c84a7f68b7", { showBorder: true }],
])

export const dailyRestriction: Map<string, ConfirmationData> = new Map([
    ["d7d88b47-190e-415c-8eb8-e9d8f23d9f39", { fontWeight: "bold" }],
])

export const dailyRestrictionInfo: Map<string, ConfirmationData> = new Map([
    ["e024d9e4-0777-4683-bbba-62810284d41d|15d8190b-2248-4f36-a176-701f53a0bb05", { showBorder: true }],
    ["e024d9e4-0777-4683-bbba-62810284d41d|87187bc2-7a0b-4f43-85ac-a8e872b90ac0", { fontWeight: "bold" }],
    ["e024d9e4-0777-4683-bbba-62810284d41d|238f0c3b-a5b9-461c-a617-a6e67597a90a", { showBorder: true }],
])

export const anemia: Map<string, ConfirmationData> = new Map([
    ["b7dc48a7-fe00-4c90-b827-f0a9b580a4fd", { fontWeight: "bold", color: "skyblue" }],
    ["ebedca39-58c1-490a-a000-ca9cec92fe18", { fontWeight: "bold" }],
    ["149d1803-5171-463c-91d4-9ab58d94d8b3|b758222a-506e-4571-9fb8-2dee27de880f", { fontWeight: "bold" }],
    ["149d1803-5171-463c-91d4-9ab58d94d8b3|f1fce74e-f51a-44ee-95dc-d31cda067b04", { fontWeight: "bold" }],
    ["149d1803-5171-463c-91d4-9ab58d94d8b3|c1e0db0d-4d06-4638-bdde-79a9703842d1", { fontWeight: "bold", showBorder: true }],
    ["75e1e0d0-9f13-49c7-9788-f3822765a394", { fontWeight: "bold" }],
])

export const anemiaTreatment: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Tratamiento", fontWeight: "bold" }],
    ["882a61e2-f700-4d14-aa77-7a2f17c9a8ce", {}],
    ["598c76c5-ae48-47cb-92e3-62cfb36a0810", { showBorder: true }],
])

export const anemia2: Map<string, ConfirmationData> = new Map([
    ["0038f1b0-f926-4134-a0f5-f3a4eee97dee|e8527f50-45fd-4098-b245-5c3d2b87f3ba", { type: "download", showBorder: true }],
])

export const mentalHealth1: Map<string, ConfirmationData> = new Map([
    ["79dacb23-2e7c-4877-85bd-198d27c80543", { fontWeight: "bold", color: "skyblue" }],
    ["ff1d561f-17f2-468c-b357-beefe374876a", { fontWeight: "bold" }],
    ["659005ae-70e5-4ae6-b419-f1b76b97c309|b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["659005ae-70e5-4ae6-b419-f1b76b97c309|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["659005ae-70e5-4ae6-b419-f1b76b97c309|116129ba-4042-4613-bc4d-18bc764d958e", {}],
    ["659005ae-70e5-4ae6-b419-f1b76b97c309|f71537b2-4802-4999-bb68-ad1265658576", {}],
    ["659005ae-70e5-4ae6-b419-f1b76b97c309|8743861d-d059-457f-a8d1-59e69ab1507d", {}],
    ["659005ae-70e5-4ae6-b419-f1b76b97c309|f1fce74e-f51a-44ee-95dc-d31cda067b04", { showBorder: true }],
    ["87b2f44d-f4f6-4d3e-bc1a-6ba7003be228", { fontWeight: "bold" }],
])

export const mentalHealth1Info: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Medicamento", fontWeight: "bold" }],
    ["2cb81471-25fc-418c-b6e0-2dd86af9aadc", {}],
    ["598c76c5-ae48-47cb-92e3-62cfb36a0810", {}],
    ["f76f697f-80e4-4c0c-8f80-1289683898ae", {}],
    ["fd236fa1-e378-4088-be6e-31eb4e0ba363", { showBorder: true }],
    ["2d94172d-d2a1-4e12-b066-f80dd4e84065", {}],
])

export const mentalHealth2: Map<string, ConfirmationData> = new Map([
    ["ee715d85-3b8d-4086-8d95-079b7c7cf9c3", { fontWeight: "bold" }],
])

export const mentalHealth2Info: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Especialista", fontWeight: "bold" }],
    ["a3fc4f2a-fd7f-4d05-8865-4c474e67c0e8", {}],
    ["09f12c9b-580a-44f3-81dd-74c6c6e40eec", {}],
    ["d1ead29b-1095-46c3-ac78-4567df198a03", { showBorder: true }],
])

export const mentalHealth2_1: Map<string, ConfirmationData> = new Map([
    ["2d01ce40-0ecf-43e1-9910-42178d8b989d", { fontWeight: "bold" }],
])

export const mentalHealth2_1Info: Map<string, ConfirmationData> = new Map([
    ["7dbab64b-dc23-47a0-8855-ac3d2b890663", { showBorder: true }],
])

export const mentalHealth2_2: Map<string, ConfirmationData> = new Map([
    ["89049566-c8e1-4c87-aaff-dce78abda041", { fontWeight: "bold" }],
])

export const mentalHealth2_2Info: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Especialista", fontWeight: "bold" }],
    ["5a1d4116-e7f2-40eb-8394-6af1c58aea75", {}],
    ["8a1c58b1-19e8-4b7a-9cff-63ce763b9ead", {}],
    ["3c043c52-1fc8-4946-936a-6958877b48ae", {}],
    ["f76f697f-80e4-4c0c-8f80-1289683898ae", {}],
    ["fd236fa1-e378-4088-be6e-31eb4e0ba363", { showBorder: true }],
])

export const mentalHealth3: Map<string, ConfirmationData> = new Map([
    ["1c928e56-cee1-4113-a04d-3504300a9c17", { fontWeight: "bold" }],
])

export const mentalHealth3Info: Map<string, ConfirmationData> = new Map([
    ["c6ce811e-bb4a-43e3-861a-518502a2ec02|418ffc57-c75d-4b4b-a996-68b6bc347821", { showBorder: true }],
])

export const mentalHealth3_1: Map<string, ConfirmationData> = new Map([
    ["3690565d-db09-48c8-82ae-31c6e04a469d", { fontWeight: "bold" }],
])

export const mentalHealth3_1Info: Map<string, ConfirmationData> = new Map([
    ["0e60275a-43cf-469b-92e7-8e8cab7bb1c3|418ffc57-c75d-4b4b-a996-68b6bc347821", { showBorder: true }],
])

export const mentalHealth3_2: Map<string, ConfirmationData> = new Map([
    ["bd16ef75-0bf3-4b7e-8277-c8c9667626df", { fontWeight: "bold" }],
])

export const mentalHealth3_2Info: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Hospitalización", fontWeight: "bold" }],
    ["375eaf8b-fedb-4a34-84df-f85fc95f2bb6", {}],
    ["f76f697f-80e4-4c0c-8f80-1289683898ae", {}],
    ["fd236fa1-e378-4088-be6e-31eb4e0ba363", { showBorder: true }],
])

export const mentalHealth4: Map<string, ConfirmationData> = new Map([
    ["df51b8ff-b912-4f99-a6d8-eae35392018c", { fontWeight: "bold" }],
])

export const mentalHealth4Info: Map<string, ConfirmationData> = new Map([
    ["cd0dd802-84a7-4042-af46-99e566a4477c|418ffc57-c75d-4b4b-a996-68b6bc347821", { showBorder: true }],
])

export const mentalHealth4_1: Map<string, ConfirmationData> = new Map([
    ["f2cb4445-74bb-43eb-b8bf-6a2a9a378c20", { fontWeight: "bold" }],
])

export const mentalHealth4_1Info: Map<string, ConfirmationData> = new Map([
    ["037e055a-3102-4553-96c5-362f506f24b8|418ffc57-c75d-4b4b-a996-68b6bc347821", { showBorder: true }],
])

export const Musculoskeletal1: Map<string, ConfirmationData> = new Map([
    ["4acac069-1734-402f-ae54-d02b86524226", { fontWeight: "bold", color: "skyblue" }],
    ["6b3f93ad-098e-4cf6-808a-d1128d3d4e1d", { fontWeight: "bold" }],
])

export const Musculoskeletal1Info: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Diagnóstico", fontWeight: "bold" }],
    ["b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["635b5555-4be9-4399-b1db-f3146385981e", {}],
    ["e03e1f37-0e12-4e31-9e9e-4b6f3a7b4d59", {}],
    ["777f6c37-3021-44aa-a5c2-d31a7efac273", {}],
    ["8743861d-d059-457f-a8d1-59e69ab1507d", {}],
    ["5afa47ed-d825-4a63-92b1-af3ba28cb115", { showBorder: true }],

])

export const Musculoskeletal2: Map<string, ConfirmationData> = new Map([
    ["fe8290b1-a6bc-447d-9065-1142efb1ed09", { fontWeight: "bold" }],
])

export const Musculoskeletal2Info: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Examen médico", fontWeight: "bold" }],
    ["42a1860e-3831-4a2e-8fe8-defedefbc791", {}],
    ["effab412-6434-4f63-a211-e4b869b475d3", {}],
    ["99a4cc3c-f1e9-40be-b290-37e45b576c4f", {}],
    ["d3b2f4a0-965a-47c2-8d93-2e0d30441155", { showBorder: true }],
])

export const Musculoskeletal2_1: Map<string, ConfirmationData> = new Map([
    ["f9a150df-68aa-4614-a1fd-7a8f88ec4dad", { fontWeight: "bold" }],
])

export const Musculoskeletal2_1Info: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Tratamiento", fontWeight: "bold" }],
    ["9f35bf51-5a4a-4ca6-976c-987d08754a06", {}],
    ["a5942cb5-6f8a-452c-9f02-40293f86a099", {}],
    ["598c76c5-ae48-47cb-92e3-62cfb36a0810", {}],
    ["f76f697f-80e4-4c0c-8f80-1289683898ae", {}],
    ["fd236fa1-e378-4088-be6e-31eb4e0ba363", {}],
])

export const Musculoskeletal3: Map<string, ConfirmationData> = new Map([
    ["19f446f5-4d60-4297-a7cd-625821f871bf", { fontWeight: "bold" }],
])

export const Musculoskeletal3Info: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Tratamiento adicional", fontWeight: "bold" }],
    ["9f35bf51-5a4a-4ca6-976c-987d08754a06", {}],
    ["d7b5ea64-2fb0-40f8-88df-f67ca38d3cee", {}],
])

export const Musculoskeletal3_1: Map<string, ConfirmationData> = new Map([
    ["04ed1c7b-2c4f-4b7d-a55d-03cf2213daa8", { fontWeight: "bold" }],
])

export const Musculoskeletal3_1Info: Map<string, ConfirmationData> = new Map([
    ["887a7d1-1903-4a12-9e45-82bd385552fc|418ffc57-c75d-4b4b-a996-68b6bc347821", { showBorder: true }],
])

export const Musculoskeletal3_2: Map<string, ConfirmationData> = new Map([
    ["892b9eb8-bbb6-43fe-91cb-9987a2daec62", { fontWeight: "bold" }],
])

export const Musculoskeletal3_2Info: Map<string, ConfirmationData> = new Map([
    ["e52a0e57-d6f0-465e-ae09-72a3602a3f3a|418ffc57-c75d-4b4b-a996-68b6bc347821", { showBorder: true }],
])

export const Musculoskeletal3_3: Map<string, ConfirmationData> = new Map([
    ["e1b43e24-9f1c-4563-8b66-7494f30a6d05", { fontWeight: "bold" }],
])

export const Musculoskeletal3_3Info: Map<string, ConfirmationData> = new Map([
    ["aa5e9f7a-dab0-497b-b58d-ca4d7dd1d145|418ffc57-c75d-4b4b-a996-68b6bc347821", { showBorder: true }],
])

export const ImmuneSystem: Map<string, ConfirmationData> = new Map([
    ["7875b8ef-c93d-46ce-a1f4-e75a38713217", { fontWeight: "bold", color: "skyblue" }],
    ["306db2f9-37f6-4ef5-b66e-8d0455b8de03", { fontWeight: "bold" }],
    ["64ccdc2d-6867-4efc-832c-b2d2082a6614|b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["64ccdc2d-6867-4efc-832c-b2d2082a6614|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["64ccdc2d-6867-4efc-832c-b2d2082a6614|f1fce74e-f51a-44ee-95dc-d31cda067b04", { showBorder: true }],
    ["cdf99e1d-c3eb-4016-ae58-d7ac5dab7329", { fontWeight: "bold" }],
])

export const ImmuneSystemTreatments: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Tratamiento", fontWeight: "bold" }],
    ["2cb81471-25fc-418c-b6e0-2dd86af9aadc", {}],
    ["598c76c5-ae48-47cb-92e3-62cfb36a0810", {}],
    ["f76f697f-80e4-4c0c-8f80-1289683898ae", {}],
    ["fd236fa1-e378-4088-be6e-31eb4e0ba363", { showBorder: true }],
])

export const ImmuneSystem2: Map<string, ConfirmationData> = new Map([
    ["95e40e5c-288c-4b74-ba98-0ef50cab7dc1|e5f4bb51-5551-4b77-8ac3-e3c1a6aa10e1", { type: "download", showBorder: true }],
])

export const surgeryConditions: Map<string, ConfirmationData> = new Map([
    ["4312fcba-90dc-4223-a7b1-2ae963235b6b", { fontWeight: "bold", color: "skyblue" }],
    ["90266267-f8ab-4943-b52c-cc293e2b3976", { fontWeight: "bold" }],
    ["4b881c08-b312-4760-b184-8f8a803b552d|b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["4b881c08-b312-4760-b184-8f8a803b552d|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["4b881c08-b312-4760-b184-8f8a803b552d|858365c8-0816-4c48-aac3-afc8d68d026f", {}],
    ["4b881c08-b312-4760-b184-8f8a803b552d|2bfb5420-9ddb-4cc8-a37b-3e39ecfe4bbf", {}],
    ["4b881c08-b312-4760-b184-8f8a803b552d|f1fce74e-f51a-44ee-95dc-d31cda067b04", {}],
    ["4b881c08-b312-4760-b184-8f8a803b552d|e5f4bb51-5551-4b77-8ac3-e3c1a6aa10e1", { type: "download", showBorder: true }],
])

export const defaultMedicalInformation2: Map<string, ConfirmationData> = new Map([
    ["e2d1d6c5-5995-4a2b-b718-ac2f3c95bc4a", { fontWeight: "bold" }],
    ["d402c344-1f3c-478e-82b9-17bafb2d350e-opt1", { type: "checkbox" }],
    ["d402c344-1f3c-478e-82b9-17bafb2d350e-opt2", { type: "checkbox" }],
    ["d402c344-1f3c-478e-82b9-17bafb2d350e-opt3", { type: "checkbox" }],
    ["d402c344-1f3c-478e-82b9-17bafb2d350e-opt4", { type: "checkbox" }],
    ["d402c344-1f3c-478e-82b9-17bafb2d350e-opt5", { type: "checkbox" }],
    ["d402c344-1f3c-478e-82b9-17bafb2d350e-opt6", { type: "checkbox", showBorder: true }],

]);

export const electrocardiograma: Map<string, ConfirmationData> = new Map([
    ["0cf2af2b-62e9-4363-8d6b-aea2845b6987", { fontWeight: "bold" }],
    ["0cf2af2b-62e9-4363-8d6b-aea2845b6987|980fd863-39a6-4854-a45f-adc7cf71dab9", { type: "download", showBorder: true }],
])

export const ecocardiograma: Map<string, ConfirmationData> = new Map([
    ["e2c0795d-ae38-4113-aa0d-82a70c563e16", { fontWeight: "bold" }],
    ["e2c0795d-ae38-4113-aa0d-82a70c563e16|980fd863-39a6-4854-a45f-adc7cf71dab9", { type: "download", showBorder: true }],
])

export const pruebaEsfuerzo: Map<string, ConfirmationData> = new Map([
    ["4825ea21-9a25-465d-91c1-1a083edc0f4d", { fontWeight: "bold" }],
    ["4825ea21-9a25-465d-91c1-1a083edc0f4d|980fd863-39a6-4854-a45f-adc7cf71dab9", { type: "download", showBorder: true }],
])

export const orina: Map<string, ConfirmationData> = new Map([
    ["a6955cc7-afff-4758-8aba-85969eeb296b", { fontWeight: "bold" }],
    ["a6955cc7-afff-4758-8aba-85969eeb296b|980fd863-39a6-4854-a45f-adc7cf71dab9", { type: "download", showBorder: true }],
])

export const pruebaFuncionRenal: Map<string, ConfirmationData> = new Map([
    ["b6286c0f-913a-487c-9427-561f283ad7f5", { fontWeight: "bold" }],
    ["b6286c0f-913a-487c-9427-561f283ad7f5|980fd863-39a6-4854-a45f-adc7cf71dab9", { type: "download", showBorder: true }],
])

export const otrosCardiaco2: Map<string, ConfirmationData> = new Map([
    ["3952e0ce-af63-443e-976d-9f80210e5d21", { fontWeight: "bold" }],
    ["3952e0ce-af63-443e-976d-9f80210e5d21|980fd863-39a6-4854-a45f-adc7cf71dab9", { type: "download", showBorder: true }],
])

export const GenitoUrinarios: Map<string, ConfirmationData> = new Map([

    ["af7cc509-d688-4316-9ee3-320f0322ad05", { fontWeight: "bold", color: "skyblue" }],
    ["8d024378-ba0c-42b7-ba38-ab548f2666df", { fontWeight: "bold" }],
    ["69203779-0a05-4e4d-ae3a-2ee1c8f2bbe9|b758222a-506e-4571-9fb8-2dee27de880f", {}],
    ["69203779-0a05-4e4d-ae3a-2ee1c8f2bbe9|c1e0db0d-4d06-4638-bdde-79a9703842d1", {}],
    ["69203779-0a05-4e4d-ae3a-2ee1c8f2bbe9|f1fce74e-f51a-44ee-95dc-d31cda067b04", { showBorder: true }],
    ["3d9d3f57-b9f6-42f1-90c9-0e306cf4d638", { fontWeight: "bold" }],
])

export const GenitoUrinariosMeds: Map<string, ConfirmationData> = new Map([
    ["group", { label: "Tratamiento", fontWeight: "bold" }],
    ["882a61e2-f700-4d14-aa77-7a2f17c9a8ce", {}],
    ["598c76c5-ae48-47cb-92e3-62cfb36a0810", {}],
    ["f76f697f-80e4-4c0c-8f80-1289683898ae", {}],
    ["fd236fa1-e378-4088-be6e-31eb4e0ba363", { showBorder: true }],
]);

export const updateMedicalInformation = (page: PageJson | undefined, cd: Map<string, ConfirmationData>): Map<string, ConfirmationData> => {
    if (page === undefined) {
        return new Map();
    }
    const answersMap = createQuestionValueMap(page);

    if (answersMap.get("ad1e32bd-6976-4068-80c1-6ccbd441e1ed-opt5")?.value === "SI" && answersMap.get("4ea018bf-7570-4e4c-adc5-617077134715-opt5")?.value === "SI") {
        answersMap.set("none", { value: "SI", hidden: false });
    }

    if (answersMap.get("ad1e32bd-6976-4068-80c1-6ccbd441e1ed-opt1")?.value === "SI") {

        cd = new Map([
            ...cd,
            ...defaultMedicalInformation2,
        ]);

        if (answersMap.get("d402c344-1f3c-478e-82b9-17bafb2d350e-opt1")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...electrocardiograma,
            ]);
        }

        if (answersMap.get("d402c344-1f3c-478e-82b9-17bafb2d350e-opt2")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...pruebaEsfuerzo,
            ]);
        }

        if (answersMap.get("d402c344-1f3c-478e-82b9-17bafb2d350e-opt3")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...ecocardiograma,
            ]);
        }

        if (answersMap.get("d402c344-1f3c-478e-82b9-17bafb2d350e-opt4")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...orina,
            ]);
        }

        if (answersMap.get("d402c344-1f3c-478e-82b9-17bafb2d350e-opt5")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...pruebaFuncionRenal,
            ]);
        }

        if (answersMap.get("d402c344-1f3c-478e-82b9-17bafb2d350e-opt6")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...otrosCardiaco2,
            ]);
        }

        cd = new Map([
            ...cd,
            ...cardiacDiseaseInfo
        ]);


        if (answersMap.get("4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt1")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...ColesterolTrigliceridos,
            ]);
        }

        if (answersMap.get("4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt2")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...DolorToracicoBypass,
            ]);
        }

        if (answersMap.get("4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt3")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...EnfermedadVenasArterias,
            ]);
        }

        if (answersMap.get("4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt4")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...ArritmiaMarcapasos,
            ]);
        }

        if (answersMap.get("4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt5")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...Aneurisma,
            ]);
        }

        if (answersMap.get("4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt7")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...AtaqueIsquemicoTransitorio,
            ]);
        }

        if (answersMap.get("4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt6")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...AccidenteCerebrovascular,
            ]);
        }

        if (answersMap.get("4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt8")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...EnfermedadValvular,
            ]);
        }

        if (answersMap.get("4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt9")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...HipertensionPulmonarInsuficienciaCardiaca,
            ]);
        }

        if (answersMap.get("4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt10")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...OtrosCardiovascular,
            ]);
        }
    }

    if (answersMap.get("4bef99f1-15b1-4832-8f1e-6301c3bf3f39-opt0")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...PresionArterialAlta,
        ]);
    }


    if (answersMap.get("ad1e32bd-6976-4068-80c1-6ccbd441e1ed-opt2")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...respiratoryDisordersInfo
        ]);
    }

    if (answersMap.get("e66d0bf8-12f3-440e-b0a3-165aacb69966-opt0")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...AsmaInfo
        ]);
    }

    if (answersMap.get("e66d0bf8-12f3-440e-b0a3-165aacb69966-opt1")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...EPOCInfo
        ]);
    }

    if (answersMap.get("e66d0bf8-12f3-440e-b0a3-165aacb69966-opt2")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...EnfisemaInfo
        ]);
    }

    if (answersMap.get("e66d0bf8-12f3-440e-b0a3-165aacb69966-opt3")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...FibrosisInfo
        ]);
    }

    if (answersMap.get("e66d0bf8-12f3-440e-b0a3-165aacb69966-opt4")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...BronquitisCronicaInfo
        ]);
    }

    if (answersMap.get("e66d0bf8-12f3-440e-b0a3-165aacb69966-opt5")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...ApneaSuenoInfo
        ]);
    }

    if (answersMap.get("e66d0bf8-12f3-440e-b0a3-165aacb69966-opt6")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...OtrosRespiratoriosInfo
        ]);
    }

    if (answersMap.get("ad1e32bd-6976-4068-80c1-6ccbd441e1ed-opt2")?.value === "SI") {
        const RespiratoryIllnessHospitalizationsItems = getUpdatedItems(page, "447d9a4e-425e-40ce-a28b-51df3e5ead19", "c6d2919e-e3c5-450d-b6be-79520fb5611e", RespiratoryIllnessHospitalizations, false);
        const RespiratoryIllnessTreatmentsItems = getUpdatedItems(page, "189d0841-8368-4cb1-9a79-be70fe47d1a3", "6bed9497-e462-4929-99b6-b299cedb8e3a", RespiratoryIllnessTreatments, false);
        cd = new Map([
            ...cd,
            ...hospitalizedForRespiratoryIllness,
        ]);

        if (answersMap.get("6e742436-3fb5-4a48-baa1-6a14da69d1d0")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...RespiratoryIllnessHospitalizationsItems,
                ...RespiratoryIllnessTreatmentsItems,
            ]);
        }
        cd = new Map([
            ...cd,
            ...respiratoryExamForThisCondition,
        ]);

        if (answersMap.get("6efe9ebc-13b3-4739-8615-6adf2a013bd5")?.value === "Sí") {
            const respiratoryExamsItems = getUpdatedItems(page, "d6ee97cc-e6e7-4b88-921a-96417304925e", "52002aca-29ab-487b-a393-f11466f6b992", respiratoryExams, false);
            cd = new Map([
                ...cd,
                ...respiratoryExamsItems,
            ]);
        }

        cd = new Map([
            ...cd,
            ...peakFlowMeterRespiratory,
        ]);

        if (answersMap.get("32372f90-16df-4f7c-9c87-cf4b9419415a")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...peakFlowMeterRespiratoryInformation,
            ]);
        }

        cd = new Map([
            ...cd,
            ...specialistReview,
        ]);

        if (answersMap.get("51a1c669-113d-402c-9134-981764ea56ad")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...specialistInfo,
            ]);
        }

        cd = new Map([
            ...cd,
            ...restrictedActivities,
        ]);

        if (answersMap.get("418709fb-bcf4-411e-8e9d-2098c7d63cc3")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...restrictedActivitiesInfo,
            ]);
        }
    }

    if (answersMap.get("ad1e32bd-6976-4068-80c1-6ccbd441e1ed-opt3")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...cancerDiagnosticInfo,
        ]);

        if (answersMap.get("1bb538a0-a29e-4fdc-8cf4-2415f71d6213-opt0")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...cancerQuimioterapia,
            ]);
        }

        if (answersMap.get("1bb538a0-a29e-4fdc-8cf4-2415f71d6213-opt1")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...cancerRadioterapia,
            ]);
        }

        if (answersMap.get("1bb538a0-a29e-4fdc-8cf4-2415f71d6213-opt2")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...cancerMonitoreo,
            ]);
        }

        if (answersMap.get("1bb538a0-a29e-4fdc-8cf4-2415f71d6213-opt3")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...cancerOtrosMedicamentos,
            ]);
        }


        cd = new Map([
            ...cd,
            ...surgeryOrBiopsy,
        ]);

        if (answersMap.get("02af736d-f315-4ea8-b4a5-d16783e855ed")?.value === "Sí") {
            const surgeriesItems = getUpdatedItems(page, "45129f3f-7f0e-4108-8299-429da5b59022", "22c3a958-4cbc-4832-aa43-16fc1bf6668b", surgeries, false);

            cd = new Map([
                ...cd,
                ...surgeriesItems,
            ]);
        }
    }

    if (answersMap.get("ad1e32bd-6976-4068-80c1-6ccbd441e1ed-opt4")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...DiabetesInfo,
        ]);

        if (answersMap.get("0d739a14-3501-4363-8603-9d285b1f118e-opt1")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...DiabetesAlteracionGlucosa,
            ]);
        }

        if (answersMap.get("0d739a14-3501-4363-8603-9d285b1f118e-opt3")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...adrenalDisorders,
            ]);
        }

        cd = new Map([
            ...cd,
            ...urineAbnormalResults,
        ]);

        if (answersMap.get("a532c924-9d90-4f5d-8904-379f457b300a")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...urineAbnormalResultsInfo,
            ]);
        }
    }

    if (answersMap.get("d97c485f-51db-40fe-8304-6cc457a095a4-opt2")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...DigestiveSystem,
        ]);

        if (answersMap.get("715a5ed4-9011-4064-97f2-52b0e17f1ca2-opt1")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...Esophagus,
            ]);
        }

        if (answersMap.get("715a5ed4-9011-4064-97f2-52b0e17f1ca2-opt2")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...Stomach,
            ]);
        }

        if (answersMap.get("715a5ed4-9011-4064-97f2-52b0e17f1ca2-opt3")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...Liver,
            ]);
        }

        if (answersMap.get("715a5ed4-9011-4064-97f2-52b0e17f1ca2-opt4")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...Gallbladder,
            ]);
        }

        if (answersMap.get("715a5ed4-9011-4064-97f2-52b0e17f1ca2-opt5")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...Pancreas,
            ]);
        }

        if (answersMap.get("715a5ed4-9011-4064-97f2-52b0e17f1ca2-opt6")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...Intestines,
            ]);
        }

        const DigestiveSystemTreatmentItems = getUpdatedItems(page, "b342682f-8f14-4696-a6b0-061b212c58a0", "f30fe94a-0894-4422-9137-6b4f08dd763a", DigestiveSystemTreatment, false);

        cd = new Map([
            ...cd,
            ...DigestiveSystemTreatmentItems,
        ]);

        cd = new Map([
            ...cd,
            ...DigestiveSystem2,
        ]);
    }

    if (answersMap.get("d97c485f-51db-40fe-8304-6cc457a095a4-opt3")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...NeurologicalDisorders,
        ]);

        if (answersMap.get("87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt1")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...Convulsiones,
            ]);
        }

        if (answersMap.get("87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt2")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...FatigaCrónica,
            ]);
        }

        if (answersMap.get("87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt3")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...Mareos,
            ]);
        }

        if (answersMap.get("87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt4")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...Parálisis,
            ]);
        }

        if (answersMap.get("87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt5")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...OtroTrastornoDelCerebro,
            ]);
        }

        if (answersMap.get("87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt6")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...TrastornoDeLaMédulaEspinal,
            ]);
        }

        if (answersMap.get("87c46b2f-8b33-4d7b-84ed-4a3aa6a95a93-opt7")?.value === "SI") {
            cd = new Map([
                ...cd,
                ...OtroTrastornoNeurológico,
            ]);
        }

        cd = new Map([
            ...cd,
            ...scannerNeurologicalDisorders,
        ]);

        if (answersMap.get("58c0fd3a-43e9-4b59-a4ea-f5814160582b")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...scannerNeurologicalDisordersInfo,
            ]);
        }

        cd = new Map([
            ...cd,
            ...statusEpilepticus,
        ])

        if (answersMap.get("dd6c14b2-387c-4be8-8263-134d3c8703a2")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...statusEpilepticusInfo,
            ]);
        }

        cd = new Map([
            ...cd,
            ...statusEpilepticusInfo2,
        ])

        const NeurologicalDisordersTreatmentsItems = getUpdatedItems(page, "ff234cc7-87bb-45ea-9411-0c531d072421", "a34285fe-8332-4c16-82b5-f7323658490b", NeurologicalDisordersTreatments, false);

        cd = new Map([
            ...cd,
            ...NeurologicalDisordersTreatmentsItems,
        ]);

        cd = new Map([
            ...cd,
            ...NeurologicalDisordersOtherTreatmentsInfo,
        ])

        cd = new Map([
            ...cd,
            ...NeurologicalDisordersOtherTreatments,
        ]);

        if (answersMap.get("2d94172d-d2a1-4e12-b066-f80dd4e84065")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...NeurologicalDisordersTreatmentsInfo,
            ]);
        }

        cd = new Map([
            ...cd,
            ...statusEpilepticusHospitalization,
        ])

        if (answersMap.get("a0fd74da-aebc-42dd-bff3-5175eb63133d")?.value === "Sí") {
            const items = getUpdatedItems(page, "fe07c9a2-1e50-40d3-a535-3619d02fecf3", "afcf942b-c503-4719-af4b-711a3b0d24e0", statusEpilepticusHospitalizationInfo, false);
            cd = new Map([
                ...cd,
                ...items,
            ]);
        }

        cd = new Map([
            ...cd,
            ...statusEpilepticusSupervision,
        ])

        if (answersMap.get("10db1210-1744-498a-862e-81db744f6f44")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...statusEpilepticusSupervisionInfo,
            ]);
        }

        cd = new Map([
            ...cd,
            ...driverLicenseRestriction,
        ])

        if (answersMap.get("903532d1-bc43-4e64-8ffb-0069534fa03e")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...driverLicenseRestrictionInfo,
            ]);
        }

        cd = new Map([
            ...cd,
            ...dailyRestriction,
        ])

        if (answersMap.get("d7d88b47-190e-415c-8eb8-e9d8f23d9f39")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...dailyRestrictionInfo,
            ]);
        }
    }


    if (answersMap.get("d97c485f-51db-40fe-8304-6cc457a095a4-opt4")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...anemia,

        ])

        const items = getUpdatedItems(page, "75e1e0d0-9f13-49c7-9788-f3822765a394", "0038f1b0-f926-4134-a0f5-f3a4eee97dee", anemiaTreatment, false);
        cd = new Map([
            ...cd,
            ...items,
        ])

        cd = new Map([
            ...cd,
            ...anemia2,
        ])

    }

    if (answersMap.get("4ea018bf-7570-4e4c-adc5-617077134715-opt1")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...mentalHealth1,
        ])

        if (answersMap.get("87b2f44d-f4f6-4d3e-bc1a-6ba7003be228")?.value === "Sí") {
            const items = getUpdatedItems(page, "18dcf02f-b948-4702-837d-7454b34004e8", "dc2b365c-d2bb-4079-b763-d451c34d504e", mentalHealth1Info, false);
            cd = new Map([
                ...cd,
                ...items,
            ])
        }

        cd = new Map([
            ...cd,
            ...mentalHealth2,
        ])

        if (answersMap.get("ee715d85-3b8d-4086-8d95-079b7c7cf9c3")?.value === "Sí") {
            const items = getUpdatedItems(page, "8f128e92-8838-4776-bc88-5e16cd5f1b85", "c82401cc-151e-4bf8-8379-f376b4b01335", mentalHealth2Info, false);
            cd = new Map([
                ...cd,
                ...items,
            ])
        }

        cd = new Map([
            ...cd,
            ...mentalHealth2_1,
        ])

        if (answersMap.get("2d01ce40-0ecf-43e1-9910-42178d8b989d")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...mentalHealth2_1Info,
            ])
        }

        cd = new Map([
            ...cd,
            ...mentalHealth2_2,
        ])

        if (answersMap.get("89049566-c8e1-4c87-aaff-dce78abda041")?.value === "Sí") {

            const items = getUpdatedItems(page, "f18c3eba-8623-4df1-82c9-fccc5cb84f68", "2c7d2571-616c-4bec-b2bf-c74a986c9d92", mentalHealth2_2Info, false);
            cd = new Map([
                ...cd,
                ...items,
            ])
        }

        cd = new Map([
            ...cd,
            ...mentalHealth3,
        ])

        if (answersMap.get("1c928e56-cee1-4113-a04d-3504300a9c17")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...mentalHealth3Info,
            ])
        }

        cd = new Map([
            ...cd,
            ...mentalHealth3_1,
        ])

        if (answersMap.get("3690565d-db09-48c8-82ae-31c6e04a469d")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...mentalHealth3_2Info,
            ])
        }

        cd = new Map([
            ...cd,
            ...mentalHealth3_2,
        ])

        if (answersMap.get("bd16ef75-0bf3-4b7e-8277-c8c9667626df")?.value === "Sí") {
            const items = getUpdatedItems(page, "b5715941-bd1e-4355-a8a5-78aff5cf4936", "4304aa4b-5f97-46ec-ba40-13560cce1c20", mentalHealth3_2Info, false);
            cd = new Map([
                ...cd,
                ...items,
            ])
        }

        cd = new Map([
            ...cd,
            ...mentalHealth4,
        ])

        if (answersMap.get("df51b8ff-b912-4f99-a6d8-eae35392018c")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...mentalHealth4Info,
            ])
        }

        cd = new Map([
            ...cd,
            ...mentalHealth4_1,
        ])

        if (answersMap.get("f2cb4445-74bb-43eb-b8bf-6a2a9a378c20")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...mentalHealth4_1Info,
            ])
        }

    }

    if (answersMap.get("4ea018bf-7570-4e4c-adc5-617077134715-opt2")?.value === "SI") {

        cd = new Map([
            ...cd,
            ...Musculoskeletal1,
        ])

        const items = getUpdatedItems(page, "6b3f93ad-098e-4cf6-808a-d1128d3d4e1d", "c989b913-c58c-4fd8-b679-bfb315efad71", Musculoskeletal1Info, false);
        cd = new Map([
            ...cd,
            ...items,
        ])

        cd = new Map([
            ...cd,
            ...Musculoskeletal2,
        ])

        const items2 = getUpdatedItems(page, "fe8290b1-a6bc-447d-9065-1142efb1ed09", "ae3fdbb0-ce71-463c-90f6-99807434a846", Musculoskeletal2Info, false);
        cd = new Map([
            ...cd,
            ...items2,
        ])

        cd = new Map([
            ...cd,
            ...Musculoskeletal2_1,
        ])

        const items3 = getUpdatedItems(page, "f9a150df-68aa-4614-a1fd-7a8f88ec4dad", "d82d3567-9dda-4b43-83c1-2b1b7e809ff3", Musculoskeletal2_1Info, false);
        cd = new Map([
            ...cd,
            ...items3,
        ])

        cd = new Map([
            ...cd,
            ...Musculoskeletal3,
        ])

        if (answersMap.get("19f446f5-4d60-4297-a7cd-625821f871bf")?.value === "Sí") {
            const items4 = getUpdatedItems(page, "552c9b04-8635-4669-8ae2-c312790d0ca8", "23852b2b-71b3-448f-90c6-f15f9bf5f460", Musculoskeletal3Info, false);
            cd = new Map([
                ...cd,
                ...items4,
            ])
        }

        cd = new Map([
            ...cd,
            ...Musculoskeletal3_1,
        ])

        if (answersMap.get("04ed1c7b-2c4f-4b7d-a55d-03cf2213daa8")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...Musculoskeletal3_1Info,
            ])
        }

        cd = new Map([
            ...cd,
            ...Musculoskeletal3_2,
        ])

        if (answersMap.get("892b9eb8-bbb6-43fe-91cb-9987a2daec62")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...Musculoskeletal3_2Info,
            ])
        }

        cd = new Map([
            ...cd,
            ...Musculoskeletal3_3,
        ])

        if (answersMap.get("e1b43e24-9f1c-4563-8b66-7494f30a6d05")?.value === "Sí") {
            cd = new Map([
                ...cd,
                ...Musculoskeletal3_3Info,
            ])
        }
    }

    if (answersMap.get("d97c485f-51db-40fe-8304-6cc457a095a4-opt1")?.value === "SI") {
        const GenitoUrinariosMedsItems = getUpdatedItems(page, "3d9d3f57-b9f6-42f1-90c9-0e306cf4d638", "94d3fc80-af8f-4f0e-9bc0-9358683ca2b6", GenitoUrinariosMeds, false);
        cd = new Map([
            ...cd,
            ...GenitoUrinarios,
            ...GenitoUrinariosMedsItems,
        ]);
    }

    if (answersMap.get("4ea018bf-7570-4e4c-adc5-617077134715-opt3")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...ImmuneSystem,
        ])

        const items = getUpdatedItems(page, "cdf99e1d-c3eb-4016-ae58-d7ac5dab7329", "95e40e5c-288c-4b74-ba98-0ef50cab7dc1", ImmuneSystemTreatments, false);
        cd = new Map([
            ...cd,
            ...items,
        ])

        cd = new Map([
            ...cd,
            ...ImmuneSystem2,
        ])
    }

    if (answersMap.get("4ea018bf-7570-4e4c-adc5-617077134715-opt4")?.value === "SI") {
        cd = new Map([
            ...cd,
            ...surgeryConditions,
        ])
    }

    return updateMapWithFields(mapToTupleArray(answersMap), cd);
}
